import { MarkdownContent, Progress, WarningPanel } from '@backstage/core-components';
import { EntityInfoCard } from '@backstage/plugin-catalog-react';
import { useEntityMarkdown } from './useEntityMarkdown';

export const EntityMarkdownCard = () => {
  const { value, loading, error } = useEntityMarkdown();

  const nothingToShow = !value && !loading && !error;
  if (nothingToShow) {
    return null;
  }
  const { markdown, title } = value || {};
  return (
    <EntityInfoCard title={title}>
      {loading && <Progress />}
      {error && <WarningPanel title="Could not load markdown" children={String(error)} />}
      {markdown && <MarkdownContent content={markdown} />}
    </EntityInfoCard>
  );
};
